/**
 * Defines the constants used by the Jobs module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
export const VUEX_APP_INIT = 'VUEX_APP_INIT'
export const VUEX_APP_INITIALIZED = 'VUEX_APP_INITIALIZED'